import { LoadablePaint } from '@confluence/loadable';

export const LazyDefaultSpaceLogoConfigPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DefaultSpaceLogoConfigContainer" */ '../src/DefaultSpaceLogoConfig/DefaultSpaceLogoConfigPage.tsx'
			)
		).DefaultSpaceLogoConfigPage,
});
